import { render, staticRenderFns } from "./PlacePoi.vue?vue&type=template&id=daa50454&"
import script from "./PlacePoi.vue?vue&type=script&lang=js&"
export * from "./PlacePoi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports